const hasPortalId = () => !!window.location.href.match(/^https?:\/\/(?:app|local).hubspot(?:qa)?.com\/docs\/(?:\d+)(?:\/.*)?$/);
export const needsAuth = hasPortalId;
export const emptyAuthData = {
  user: {},
  allGates: [],
  gates: {},
  portal: {},
  scopes: {}
};